export const SiteFeatureConfigSymbol = Symbol('SiteFeatureConfig')
export const EditorFeatureConfigSymbol = Symbol('EditorFeatureConfig')
export const PageFeatureConfigSymbol = Symbol('PageFeatureConfig')
export const MasterPageFeatureConfigSymbol = Symbol('MasterPageFeatureConfig')
export const FeatureStateSymbol = Symbol('FeatureState')
export const FeatureExportsSymbol = Symbol('FeatureExports')
export const DynamicPagesSymbol = Symbol('DynamicPagesSymbol')
